import { Layout } from "@citi-icg-172888/icgds-patterns-react";
import { Button, Icon } from "@citi-icg-172888/icgds-react";
import React, { useCallback } from "react";

interface FooterButtonHocProps {
  submitText?: string;
  cancelText?: string;
  backText?: string;
  class?: string;
  onCancel?: () => void;
  onBack?: () => void;
  onSubmit?: () => void;
  submitDisabled?: boolean;
  closeSubmission?: boolean;
  showDivider?: boolean;
  isLoading?: boolean;
  id?: string;
}

const FooterButtonHoc: React.FC<FooterButtonHocProps> = ({
  submitText,
  cancelText,
  backText,
  onCancel,
  onBack,
  onSubmit,
  submitDisabled,
  closeSubmission,
  showDivider,
  isLoading,
  id,
}) => {
  const onClickCancel = useCallback(() => {
    onCancel && onCancel();
  }, [onCancel]);

  const onClickSubmit = useCallback(() => {
    onSubmit && onSubmit();
  }, [onSubmit]);

  const onBackHandler = useCallback(() => {
    onBack && onBack();
  }, [onBack]);
  const onCloseCall = (item: any, closeSubmission: any) => {
    if (closeSubmission) {
      return "lmn-justify-content-end";
    } else if (item) {
      return "lmn-dnca-justify-content";
    }
    return "";
  };

  return (
    <>
      {showDivider && <Layout type="divider" layoutClass="cust-border-color" />}
      <div
        id="footer_button"
        className={`lmn-dcna-m-flex-container lmn-dcna-s-flex-container lmn-dcna-l-flex ${onCloseCall(!onBack, closeSubmission)}`}
      >
        {onCancel && (
          <div>
            <Button
              className="lmn-dnca-w-s-100 lmn-dnca-w-xs-100 lmn-mb-2 lmn-mr-3 first"
              style={{ color: "#fff", background: "transparent", boxShadow: "inset 0 0 0 1px" }}
              onClick={onClickCancel}
              aria-label={cancelText}
            >
              {cancelText}
            </Button>
          </div>
        )}

        {onBack && (
          <Button
            className="lmn-dnca-w-s-100 lmn-dnca-w-xs-100 lmn-mb-2 lmn-mr-3 lmn-ml-md-auto lmn-ml-sm-auto second lmn-dnca-ml-lg lmn-dnca-ml-xl"
            style={{ color: "#fff", background: "transparent", boxShadow: "inset 0 0 0 1px" }}
            onClick={onBackHandler}
            aria-label={backText}
          >
            {backText}
          </Button>
        )}
        {submitText && (
          <Button
            className={`lmn-dnca-w-s-100 lmn-dnca-w-xs-100 lmn-mb-2 three ${onBack ? "" : "lmn-ml-sm-auto"}`}
            color="primary"
            style={{
              background: "#255BE3",
              borderRadius: "6px",
            }}
            id={id}
            aria-label={submitText}
            disabled={submitDisabled || isLoading}
            onClick={onClickSubmit}
          >
            {submitText}
            {isLoading && <Icon type="spinner" spin />}
          </Button>
        )}
      </div>
    </>
  );
};
FooterButtonHoc.defaultProps = {
  cancelText: "Cancel",
  backText: "Go Back",
  submitDisabled: false,
  showDivider: true,
};

export default FooterButtonHoc;
